// extracted by mini-css-extract-plugin
export default {"documentView":"DocumentView_documentView__Od-L9","uploadDate":"DocumentView_uploadDate__29Z3Q","document":"DocumentView_document__IpcVU"};